import { useQuery } from '@hooks/reactQuery';

import { getDeltasBranch } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted } from '@utils/formatter';

import { TNameTitle } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { MO_BRANCH_DELTAS } from '@constants/queryKeys';

export const useQueryDeltasBranch = (comparisonId: string) => {
	const {
		data: deltasOptions,
		isLoading: isLoadingDeltas,
	} = useQuery({
		queryKey: [MO_BRANCH_DELTAS, comparisonId],
		queryFn: extractQueryParams(getDeltasBranch),
		select: (options: Array<TNameTitle>) => optionsFormatted(options),
		...refetchOptions,
	});

	return { deltasOptions: deltasOptions || [], isLoadingDeltas };
};
